import React, { useState, useEffect } from "react";
import {Button, Container, Form, Row, Col, Card, Badge} from "react-bootstrap";
import Relic from "./Relic";

const NinjaRelics = (props) => {

    const handleClickRelicSlot = (index) => {
        props.setCurrentSide(props.side);
        // TODO do not allow 2 relics of the same type to be equipped...aka 2 rings
        const currentRelic = props.relics[index];
        if (props.readyToEquip)
        {
            equipRelic(index);
        }
        else if (currentRelic != null)
        {
            showEquippedRelic(index, currentRelic);
        }
    };

    const equipRelic = (index) => {
        props.selectedRelic.level = props.selectedLevel;

        if (index === 4)
        {
            if (props.selectedRelic.hasOwnProperty('ninja'))
            {
                let relicNinja = props.selectedRelic.ninja;
                if (props.ninja.name === relicNinja)
                {
                    props.relics[index] = props.selectedRelic;
                    props.setRelics([...props.relics]);
                }
                else
                {
                    window.alert('Ninja must be ' + relicNinja + ' for this relic to be equipped in the 5th slot.');
                }
            }
            else
            {
                window.alert('Relic may not be equipped in the 5th slot.');
            }
        }
        else if (isUniqueRelic(props.selectedRelic))
        {
            props.relics[index] = props.selectedRelic;
            props.setRelics([...props.relics]);
        }
        else
        {
            window.alert('Relic is already equipped.');
        }

        props.setSelectedRelic(null);
        props.setShowSelection(false);
        props.setReadyToEquip(false);
    };

    const isUniqueRelic = () => {
        let i, len;
        for (i = 0, len = props.relics.length; i < len; i++)
        {
            let equippedRelic = props.relics[i];
            if (equippedRelic && equippedRelic.value === props.selectedRelic.value)
            {
                return false;
            }
        }
        return true
    };

    const showEquippedRelic = (index, currentRelic) => {
        props.setSelectedRelic(currentRelic);
        props.setSelectionButtonText('Remove');
        props.setIndexToRemove(index);
        if (!props.showSelection)
        {
            props.setShowSelection(true);
        }
    };

    return (
        <Container className="p-1">
            <div className="text-center">{'Ninja ' + props.side}</div>
            <Card className={"p-0 m-0 relics"+props.side} style={{width: '80px'}}>
                <Card.Body className="holder pt-1 pb-1">
                <Row xs={1}>
                    {
                        props.relics.map((relic, index) => {
                            return (
                                <Col className="p-0" key={index}  onClick={() => handleClickRelicSlot(index)}>
                                    <Relic relic={relic}/>
                                </Col>
                            )
                        })
                    }
                </Row>
                </Card.Body>
            </Card>
        </Container>
    );
};

export default NinjaRelics;